import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: theme.spacing(1),
    width: theme.spacing(12),
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor: theme.palette.primary.main,
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      backgroundColor: 'rgba(0,140,255, 0.1)',
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  menuPaper: {
    maxHeight: 200,
  },
  title: {
    // paddingLeft: theme.spacing(0.5),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  }
}));

const ITEM_HEIGHT = 48;

const CustomMenu = ({ title, options, handleChange, value }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {options && (
        <>
          <FormControl variant="outlined" className={classes.margin}>
            <InputLabel className={classes.title}>{title}</InputLabel>
            <Select
              id="demo-customized-select-native"
              value={value}
              onChange={handleChange}
              input={<BootstrapInput />}
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >
              {options.map((option) => (
                <MenuItem value={option.label}>{option.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
    </div>
  );
}

export default CustomMenu;
